import React, { SVGProps } from 'react'
const SvgGreyLock = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#1B2C4F'}
      fillRule="evenodd"
      d="M11.806 5.539a3.834 3.834 0 0 0-7.612 0h-.527A.462.462 0 0 0 3.205 6v7.334c0 .255.207.461.462.461h8.666a.462.462 0 0 0 .462-.461V6a.462.462 0 0 0-.462-.461h-.527Zm-7.678.923h7.743v6.41H4.128v-6.41Zm1.076-.924a2.834 2.834 0 0 1 5.592 0H5.204Zm3.291 3.394A.5.5 0 0 0 7.5 9v1.667l.005.068a.5.5 0 0 0 .995-.068V9l-.005-.068Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgGreyLock
